/* ===========================================================
   AFINA Header — menu-driven mega menu, mobile nav, cart drawer.
   =========================================================== */
(function () {
  'use strict';
  var root = document.querySelector('[data-afina-hdr]');
  if (!root) return;
  var header = root.querySelector('.header');
  var mobile = root.querySelector('[data-hdr-mobile]');
  var scrim = root.querySelector('[data-hdr-scrim]');
  var burger = root.querySelector('[data-hdr-burger]');

  function setOpen(el, on) { if (el) el.setAttribute('data-open', on ? 'true' : 'false'); }
  setOpen(mobile, false);

  // --- Mega menu (one panel per top-level menu item with children) ---
  var panels = root.querySelectorAll('[data-hdr-panel]');
  var triggers = root.querySelectorAll('[data-hdr-dd]');
  var openKey = null;
  panels.forEach(function (p) { setOpen(p, false); });
  function openPanel(key) {
    openKey = key;
    panels.forEach(function (p) { setOpen(p, p.getAttribute('data-hdr-panel') === key); });
    triggers.forEach(function (t) { t.setAttribute('aria-expanded', t.getAttribute('data-hdr-dd') === key ? 'true' : 'false'); });
  }
  function closePanels() {
    openKey = null;
    panels.forEach(function (p) { setOpen(p, false); });
    triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
  }
  triggers.forEach(function (t) {
    var k = t.getAttribute('data-hdr-dd');
    t.addEventListener('mouseenter', function () { openPanel(k); });
    t.addEventListener('click', function (e) { e.stopPropagation(); if (openKey === k) closePanels(); else openPanel(k); });
  });
  panels.forEach(function (p) { p.addEventListener('mouseenter', function () { openPanel(p.getAttribute('data-hdr-panel')); }); });
  if (header) header.addEventListener('mouseleave', closePanels);
  document.addEventListener('click', function (e) {
    if (openKey && !e.target.closest('[data-hdr-panel]') && !e.target.closest('[data-hdr-dd]')) closePanels();
  });

  // --- Mobile nav ---
  var mobOn = false;
  function mob_(on) {
    mobOn = on; setOpen(mobile, on);
    if (burger) burger.setAttribute('aria-expanded', on);
    if (scrim) scrim.hidden = !on;
    document.documentElement.style.overflow = on ? 'hidden' : '';
  }
  if (burger) burger.addEventListener('click', function () { mob_(!mobOn); });
  if (scrim) scrim.addEventListener('click', function () { mob_(false); });
  if (mobile) mobile.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { mob_(false); }); });

  /* Collapsible sub-groups in the mobile nav (e.g. "Replacement Filter for").
     Buttons, not links, so they don't trip the close-on-link handler above. */
  root.querySelectorAll('[data-hdr-subtoggle]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var g = b.closest('[data-hdr-subgroup]'); if (!g) return;
      var on = g.getAttribute('data-open') === 'true';
      g.setAttribute('data-open', on ? 'false' : 'true');
      b.setAttribute('aria-expanded', on ? 'false' : 'true');
    });
  });

  // --- Cart: open Dawn cart-drawer if present ---
  var cartBtn = root.querySelector('[data-hdr-cart]');
  if (cartBtn) cartBtn.addEventListener('click', function () {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.open === 'function') { try { d.open(); return; } catch (e) {} }
    if (d && d.classList) { d.classList.remove('is-empty'); d.classList.add('active', 'animate'); d.setAttribute('open', ''); document.body.classList.add('overflow-hidden'); return; }
    window.location.href = '/cart';
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closePanels(); mob_(false); } });
})();
